const form_submit_button_error =
  'Vous avez des articles dans votre panier. Veuillez payer et enregistrer si vous souhaitez sauvegarder vos modifications'

export default form_submit_button_error
